// extracted by mini-css-extract-plugin
module.exports = {"content":"condogenie-module--content--2fu4G","image":"condogenie-module--image--7K42l"};